import type { CHECK_DEFINITION } from '@/typings/api';

import type governmentIntegrations from './governmentIntegrations';
import * as GovernmentIntegrationsApiModels from './governmentIntegrationsApiModels';

export { type SubmissionErrorContext, parseSubmissionErrorContext } from './validation';

export type ApiDefinitions = CHECK_DEFINITION<governmentIntegrations>;

export { GovernmentIntegrationsApiModels };
